const adminRole = {
  language: 'en-US',
  addOns: [
    {
      enabled: true,
      id: '686279a5-1006-47a2-8d7b-6a69004e18ab', // 'Stickers',
    },
    {
      enabled: true,
      id: 'b17dc240-b226-415c-af71-246fc51bd088', // 'Gifs',
    },
    {
      enabled: true,
      id: 'rowAddon', // 'Products',
    }
  ],
  advancedPermissions: {
    content: {
      title: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      button: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      image: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      form: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      text: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      paragraph: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      list: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      html: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      spacer: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      icons: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      divider: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      social: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      dynamic: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      menu: {
        behaviors: {
          canViewSidebar: true,
        }
      },
      video: {
        behaviors: {
          canViewSidebar: true,
        }
      },
    },
  }
}

export default adminRole
